<template>
    <v-container fluid grid-list-xl>
        <v-layout row justify-start>
            <v-flex d-block >
                <v-card>
                    <v-card-title>
                        <h3 v-t="'createCase.title'"></h3>
                    </v-card-title>
                    <v-card-text>
                        <case-creation-order-form ref="caseCreationOrderForm" context="createCase" :errorMessages="createCase.form.errorMessages"
                                   :caseCreationOrder="createCase.form.data" :currentClient="currentClient" :formValid="createCase.form.valid"
                                   :servicesByClients="servicesByClients" :availableServicesById="availableServicesById" :materialsCreationFormState="createCase.materialsFormValue"
                                   :missingRequiredSections="missingRequiredSections"
                                   :showRequiredSectionErrors="!canSubmitForm"
                                   :checkMaterialExistsFunc="checkMaterialExists"
                                   @createMaterial="ccofCreateMaterial" @deleteMaterial="ccofDeleteMaterial"
                                   @addService="ccofAddService" @removeService="ccofRemoveService" @changeServiceQuantity="ccofChangeServiceQuantity"
                                   @updateFiles="ccofUpdateFiles" @updateFormField="ccofUpdateFormField" @changeFormValid="handleChangeFormValid"
                        ></case-creation-order-form>
                        <v-layout row>
                            <v-flex>
                                <v-btn
                                        v-if="canImmediateCreate"
                                        :disabled="!canSubmitForm || createCase.progress"
                                        :loading="!!createCase.progressByActions['creation']"
                                        color="success"
                                        large
                                        @click="handleCreateButtonClick"
                                        v-t="'createCase.buttons.create.label'"
                                ></v-btn>
                                <v-btn
                                        v-if="canSendToValidation"
                                        :disabled="!canSubmitForm || createCase.progress"
                                        :loading="!!createCase.progressByActions['creation']"
                                        color="success"
                                        large
                                        @click="handleSendToValidationButtonClick"
                                        v-t="'createCase.buttons.toValidation.label'"
                                ></v-btn>
                                <v-btn
                                        :disabled="createCase.progress"
                                        large
                                        @click="handleResetButtonClick"
                                        v-t="'createCase.buttons.clear.label'"
                                ></v-btn>
                                <div v-if="missingRequiredFieldLabels.length > 0" class="missing-required-list">
                                    <div v-for="field in missingRequiredFieldLabels" :key="field">{{ field }}</div>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

  import {CCOF_CHANGE_FORM_VALID} from '../../store/mutations/available'
  import { hasRole } from '../../helpers/user'
  import { mapActions, mapState } from 'vuex'
  import CaseCreationOrderForm from './CaseCreationOrderForm'

  export default {
    name: 'create-case',
    components: {
      CaseCreationOrderForm: CaseCreationOrderForm
    },
    data () {
      return {
      }
    },
    computed: {
      ...mapState({
        createCase: state => state.createCase,
        currentClient: state => state.currentClient,
        servicesByClients: state => state.servicesByClients,
        availableServicesById: state => state.availableServicesById,
        user: state => state.user
      }),
      canImmediateCreate() {
        return hasRole(this.user, 'admin') || hasRole(this.user, 'clientadmin')
      },
      canSendToValidation() {
        return !hasRole(this.user, 'admin') && !hasRole(this.user, 'clientadmin')
      },
      hasRequiredFiles () {
        return (this.createCase.form.data.files || []).filter((file) => file.success).length > 0
      },
      hasRequiredServices () {
        return (this.createCase.form.data.services || []).length > 0
      },
      hasRequiredMaterials () {
        const materials = this.createCase.form.data.materials || {}
        return Object.keys(materials).some((type) => Array.isArray(materials[type]) && materials[type].length > 0)
      },
      missingRequiredSections () {
        return {
          files: !this.hasRequiredFiles,
          services: !this.hasRequiredServices,
          materials: !this.hasRequiredMaterials
        }
      },
      canSubmitForm () {
        return !!this.createCase.form.valid &&
          !this.missingRequiredSections.files &&
          !this.missingRequiredSections.services &&
          !this.missingRequiredSections.materials
      },
      missingRequiredFieldLabels () {
        if (this.canSubmitForm) {
          return []
        }
        const labels = []
        if (!this.createCase.form.data.patientName) labels.push(this.$t('caseCreationOrderForm.fields.patientName.label'))
        if (!this.createCase.form.data.patientGender) labels.push(this.$t('caseCreationOrderForm.fields.patientGender.label'))
        if (!this.createCase.form.data.patientBirthday) labels.push(this.$t('caseCreationOrderForm.fields.patientBirthday.label'))
        if (!this.createCase.form.data.diagnosis) labels.push(this.$t('caseCreationOrderForm.fields.diagnosis.label'))
        if (this.missingRequiredSections.services) labels.push(this.$t('caseCreationOrderForm.requiredSections.services'))
        if (this.missingRequiredSections.files) labels.push(this.$t('caseCreationOrderForm.requiredSections.files'))
        if (this.missingRequiredSections.materials) labels.push(this.$t('caseCreationOrderForm.requiredSections.materials'))
        return labels
      }
    },
    methods: {
      ...mapActions({
        ccofUpdateFormField: 'ccofUpdateFormField',
        ccofAddService: 'ccofAddService',
        ccofRemoveService: 'ccofRemoveService',
        ccofChangeServiceQuantity: 'ccofChangeServiceQuantity',
        ccofCreateMaterial: 'ccofCreateMaterial',
        ccofDeleteMaterial: 'ccofDeleteMaterial',
        ccofResetForm: 'ccofResetForm',
        ccofUpdateFiles: 'ccofUpdateFiles',
        doCreateCase: 'createCase',
        checkMaterialExistsFunc: 'checkMaterialExists'
      }),
      savePatientBirthday (date) {
          this.$refs.birthdayPickerMenu.save(date)
      },
      handleCreateButtonClick () {
        if (!this.$refs['caseCreationOrderForm'].validate()) {
          return
        }
        if (!this.canSubmitForm) {
          return
        }

        this.doCreateCase({vue: this, immediateCreation: true})
      },
      handleSendToValidationButtonClick () {
        if (!this.$refs['caseCreationOrderForm'].validate()) {
          return
        }
        if (!this.canSubmitForm) {
          return
        }

        this.doCreateCase({vue: this, immediateValidation: true})
      },
      handleResetButtonClick () {
        this.ccofResetForm('createCase')
        this.$refs['caseCreationOrderForm'].reset()
      },
      handleChangeFormValid (value) {
        this.$store.commit(CCOF_CHANGE_FORM_VALID, {context: 'createCase', value: value.value})
      },
      checkMaterialExists (code) {
        return this.checkMaterialExistsFunc({
          code: code,
          caseId: null
        })
      }
    }
  }
</script>


<style>
    .required-field .v-input__slot {
        background-color: #ddeaef;
    }
    .required-field .v-label::after {
        content: " *";
        color: #ff5252;
    }
    .missing-required-list {
        color: #ff5252;
        margin-top: 12px;
        font-size: 14px;
    }
</style>